export default __webpack_public_path__ + "static/media/working-company.eec9a94f.svg";